module.exports = __webpack_public_path__ + "static/media/khansaheb.a52a9c22.jpg";